export const SliderTooltipPin = ({className}: {className?: string}) => (
    <span className={className}>
        <svg
            width="12"
            height="6"
            viewBox="0 0 12 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.99996 5.02325C5.99996 5.02325 7.7674 -1.90735e-06 11.3023 -1.90735e-06H0.697632C4.23252 -1.90735e-06 5.99996 5.02325 5.99996 5.02325Z"
                fill="currentColor"
            />
        </svg>
    </span>
);
